import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Table, Popup, Button, Icon } from "semantic-ui-react";
import { useNavigate, Link } from "react-router-dom";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { IClientList } from "../../../app/models/client";
import { CompanyStateEnum } from "../../../app/util/securityEnums";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import {
  getPlanTypeEnum,
  getCompanyStateEnum,
} from "../../../app/util/securityEnumsOptions";

const ListClients = () => {
  const navigate = useNavigate();

  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    getClients,
    loadClients,
    clients,
    changeClientState,
  } = rootStore.clienStore;

  useEffect(() => {
    getClients();
  }, [getClients]);

  const handleChangeState = (b: IClientList, state: CompanyStateEnum) => {
    changeClientState({ id: b.id, state: state });
  };

  if (!loadClients) return <LoadingComponent content="Cargando" />;

  return (
    <div className="TableScroll">
    <Table striped basic  unstackable compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell >Nombre</Table.HeaderCell>
          <Table.HeaderCell>NIT</Table.HeaderCell>
          <Table.HeaderCell>Company Key</Table.HeaderCell>
          <Table.HeaderCell>Plan</Table.HeaderCell>
          <Table.HeaderCell>Estado</Table.HeaderCell>
          <Table.HeaderCell>Métricas</Table.HeaderCell>
          <Table.HeaderCell>Acciones</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {clients?.length > 0 ? (
          clients.map((c) => (
            <Table.Row key={c.id}>
              <Table.Cell singleLine>{c.name}</Table.Cell>
              <Table.Cell>{c.companyID}</Table.Cell>
              <Table.Cell>{c.companyKey}</Table.Cell>
              <Table.Cell>{getPlanTypeEnum(c.planType)}</Table.Cell>
              <Table.Cell>{getCompanyStateEnum(c.state)}</Table.Cell>
              <Table.Cell>
                <Link to={`/home/Client/DashboardGraphic/${c.id}`}>
                  <Popup
                    basic
                    content="Dashboard cliente"
                    trigger={
                      <Icon size="large" color="black" name="area graph" />
                    }
                  />
                </Link>
              </Table.Cell>

              <Table.Cell>
                <div>
                  <Popup
                    content="Editar cliente"
                    trigger={
                      <Button
                        icon
                        onClick={() =>
                          navigate(
                            `/home/Client/DashboardEditClient/${c.id}`
                          )
                        }
                      >
                        <Icon name="edit outline" color="blue" />
                      </Button>
                    }
                  />
                  {c.state === CompanyStateEnum.Active ? (
                    <Popup
                      content="Click para Inactivar cliente"
                      trigger={
                        <Button
                          icon
                          onClick={() =>
                            handleChangeState(c, CompanyStateEnum.Inactive)
                          }
                        >
                          <Icon name="unlock" color="green" />
                        </Button>
                      }
                    />
                  ) : (
                    <Popup
                      content="Click para Activar cliente"
                      trigger={
                        <Button
                          icon
                          onClick={() =>
                            handleChangeState(c, CompanyStateEnum.Active)
                          }
                        >
                          <Icon name="lock" color="red" />
                        </Button>
                      }
                    />
                  )}
                </div>
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row key="clientsNull">
            <Table.Cell>No existen clientes</Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
    </div>
  );
};

export default observer(ListClients);
